var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOfeili(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1-2",
    width: 219.748,
    height: 132.623,
    viewBox: "0 0 219.748 132.623",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17565",
    "data-name": "Path 17565",
    d: "M47.841,8.848,48.266,40.2c-.5.044-3.824.044-9.188-6.479a15.1,15.1,0,0,1-1.6-2.4c-.1-.168-.186-.345-.274-.522a23.05,23.05,0,0,1-1.257-3l-.08-.239c-.142-.416-.266-.841-.389-1.257-.053-.177-.1-.345-.142-.522L35.2,25.25c-.044-.186-.089-.363-.133-.549a1.03,1.03,0,0,1-.035-.159c-.044-.186-.089-.372-.124-.558-.035-.159-.071-.328-.106-.487l-.106-.531c-.009-.071-.027-.142-.035-.212-.035-.186-.062-.363-.1-.54-.071-.381-.124-.761-.177-1.133-.044-.31-.089-.62-.124-.921a.245.245,0,0,0-.009-.08c-.044-.31-.071-.611-.106-.912a55.239,55.239,0,0,1-.328-5.789,1.076,1.076,0,0,1,1.222-1.062h0c.115.018.23.027.336.044h0c.115.018.23.027.336.035l.328.027.319.027a11.269,11.269,0,0,0,3.2-.186c.159-.035.3-.071.443-.115s.274-.089.407-.133c.089-.035.168-.062.248-.1a4.685,4.685,0,0,0,1.257-.761A7.129,7.129,0,0,1,43.8,9.813a8.988,8.988,0,0,1,4.027-.983Z",
    transform: "translate(-33.82 -8.83)",
    fill: "#95b8d1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 67.369,
    height: 130.852,
    rx: 7.65,
    fill: "#95b8d1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17572",
    "data-name": "Path 17572",
    d: "M217.249,132H163.777a7.278,7.278,0,0,1-7.267-7.267V7.767A7.278,7.278,0,0,1,163.777.5h53.472a7.278,7.278,0,0,1,7.267,7.267V124.731A7.278,7.278,0,0,1,217.249,132ZM163.777,1.146a6.628,6.628,0,0,0-6.621,6.621V124.731a6.628,6.628,0,0,0,6.621,6.621h53.472a6.628,6.628,0,0,0,6.621-6.621V7.767a6.628,6.628,0,0,0-6.621-6.621Z",
    transform: "translate(-156.51 -0.5)",
    fill: "#95b8d1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17574",
    "data-name": "Path 17574",
    d: "M237.715,22.6v11.25H235.13V22.6a1.288,1.288,0,0,1,1.292-1.292,1.263,1.263,0,0,1,.912.381,1.3,1.3,0,0,1,.381.912Z",
    transform: "translate(-235.13 -21.31)",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17576",
    "data-name": "Path 17576",
    d: "M235.13,37.82h2.585V52.434a1.292,1.292,0,0,1-2.585,0V37.82Z",
    transform: "translate(-235.13 -37.82)",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17578",
    "data-name": "Path 17578",
    d: "M236.462,88.088h0A1.288,1.288,0,0,1,235.17,86.8V67.012a1.288,1.288,0,0,1,1.292-1.292h0a1.288,1.288,0,0,1,1.292,1.292V86.8A1.288,1.288,0,0,1,236.462,88.088Z",
    transform: "translate(-235.17 -65.72)",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113",
    "data-name": "Rectangle 113",
    width: 153.601,
    height: 131.605,
    transform: "translate(153.601 131.605) rotate(180)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    width: 74.468,
    height: 47.586,
    rx: 6.19,
    fill: "#95b8d1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 10.693,
    cy: 10.693,
    r: 10.693,
    fill: "#0d3b66"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1140",
    "data-name": "Group 1140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1094",
    "data-name": "Group 1094",
    transform: "translate(12.622)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17561",
    "data-name": "Path 17561",
    d: "M59.478,48.865a7.411,7.411,0,0,0-5.851-2.16l-34.592-.018a4.072,4.072,0,0,1-4.275-4.213V4.713A4.067,4.067,0,0,1,19.035.5H73.269a4.072,4.072,0,0,1,4.275,4.213V56.371c0,4.222-4.612,5.284-7.3,2.3L59.478,48.847Z",
    transform: "translate(-14.317 -0.057)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17562",
    "data-name": "Path 17562",
    d: "M73.751,60.766a5.3,5.3,0,0,1-3.9-1.85L59.12,49.126l-.027-.027c-1.239-1.372-3-2.018-5.523-2.018l-34.592-.018a4.532,4.532,0,0,1-4.718-4.656V4.656A4.532,4.532,0,0,1,18.978,0H73.211a4.532,4.532,0,0,1,4.718,4.656V56.322a4.22,4.22,0,0,1-2.6,4.16,4.35,4.35,0,0,1-1.567.292ZM59.73,48.489,70.476,58.3a4.157,4.157,0,0,0,4.532,1.354,3.325,3.325,0,0,0,2.036-3.337V4.656A3.639,3.639,0,0,0,73.2.885H18.969a3.644,3.644,0,0,0-3.842,3.771V42.408a3.639,3.639,0,0,0,3.842,3.771l34.592.018a7.924,7.924,0,0,1,6.161,2.293Z",
    transform: "translate(-14.26)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1098",
    "data-name": "Group 1098",
    transform: "translate(29.502 7.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17563",
    "data-name": "Path 17563",
    d: "M57.287,33.471c-5.187,6.665-8.515,6.754-9.011,6.718-.5.044-3.824.044-9.188-6.479a15.1,15.1,0,0,1-1.6-2.4c-.1-.168-.186-.345-.274-.522a23.051,23.051,0,0,1-1.257-3l-.08-.239c-.142-.416-.266-.841-.389-1.257-.053-.177-.1-.345-.142-.522l-.133-.531c-.044-.186-.089-.363-.133-.549a1.03,1.03,0,0,1-.035-.159c-.044-.186-.089-.372-.124-.558-.035-.159-.071-.328-.106-.487l-.106-.531c-.009-.071-.027-.142-.035-.212-.035-.186-.062-.363-.1-.54-.071-.381-.124-.761-.177-1.133-.044-.31-.089-.62-.124-.921a.245.245,0,0,0-.009-.08c-.044-.31-.071-.611-.106-.912a55.239,55.239,0,0,1-.328-5.789,1.076,1.076,0,0,1,1.222-1.062h0c.115.018.23.027.336.044h0c.115.018.23.027.336.035l.328.027.319.027a11.606,11.606,0,0,0,3.2-.186c.159-.035.3-.071.443-.115s.274-.089.407-.133c.089-.035.168-.062.248-.1a4.685,4.685,0,0,0,1.257-.761A7.129,7.129,0,0,1,43.815,9.8,9.289,9.289,0,0,1,51.9,9.687a7.441,7.441,0,0,1,1.93,1.292c1.089.867,3.054,1.584,6.931.965A1.079,1.079,0,0,1,62,12.989c.08,3.682-.1,14.525-4.718,20.465Z",
    transform: "translate(-33.387 -8.377)",
    fill: "#95b8d1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1096",
    "data-name": "Group 1096",
    transform: "translate(0.434 0.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17564",
    "data-name": "Path 17564",
    d: "M47.841,8.848,48.266,40.2c-.5.044-3.824.044-9.188-6.479a15.1,15.1,0,0,1-1.6-2.4c-.1-.168-.186-.345-.274-.522a23.05,23.05,0,0,1-1.257-3l-.08-.239c-.142-.416-.266-.841-.389-1.257-.053-.177-.1-.345-.142-.522L35.2,25.25c-.044-.186-.089-.363-.133-.549a1.03,1.03,0,0,1-.035-.159c-.044-.186-.089-.372-.124-.558-.035-.159-.071-.328-.106-.487l-.106-.531c-.009-.071-.027-.142-.035-.212-.035-.186-.062-.363-.1-.54-.071-.381-.124-.761-.177-1.133-.044-.31-.089-.62-.124-.921a.245.245,0,0,0-.009-.08c-.044-.31-.071-.611-.106-.912a55.239,55.239,0,0,1-.328-5.789,1.076,1.076,0,0,1,1.222-1.062h0c.115.018.23.027.336.044h0c.115.018.23.027.336.035l.328.027.319.027a11.269,11.269,0,0,0,3.2-.186c.159-.035.3-.071.443-.115s.274-.089.407-.133c.089-.035.168-.062.248-.1a4.685,4.685,0,0,0,1.257-.761A7.129,7.129,0,0,1,43.8,9.813a8.988,8.988,0,0,1,4.027-.983Z",
    transform: "translate(-33.82 -8.83)",
    fill: "#95b8d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1097",
    "data-name": "Group 1097",
    transform: "translate(14.012 0.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17566",
    "data-name": "Path 17566",
    d: "M50.082,43.893a.448.448,0,0,1-.443-.434l-.08-5.807a.442.442,0,0,1,.434-.443.454.454,0,0,1,.443.434l.08,5.807a.442.442,0,0,1-.434.443Z",
    transform: "translate(-49.206 -11.664)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17567",
    "data-name": "Path 17567",
    d: "M49.78,22a.448.448,0,0,1-.443-.434L49.16,8.793a.438.438,0,0,1,.876-.009l.177,12.773A.442.442,0,0,1,49.78,22Z",
    transform: "translate(-49.16 -8.35)",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17568",
    "data-name": "Path 17568",
    d: "M49.278,32.192a1.821,1.821,0,0,1-1.292-.522L41.86,25.641a1.8,1.8,0,1,1,2.532-2.567l4.629,4.559,7.418-10.25a1.807,1.807,0,1,1,2.93,2.116l-8.648,11.95a1.817,1.817,0,0,1-1.31.744h-.124Z",
    transform: "translate(-34.248 -9.274)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17569",
    "data-name": "Path 17569",
    d: "M48.059,40.584c-.983,0-4.328-.513-9.374-6.639a15.973,15.973,0,0,1-1.646-2.47c-.1-.168-.186-.345-.283-.531a23.239,23.239,0,0,1-1.275-3.063l-.08-.239c-.142-.416-.266-.841-.4-1.275L34.72,25.3c-.044-.177-.089-.372-.133-.558-.009-.044-.027-.1-.035-.159l-.124-.566c-.035-.159-.071-.328-.106-.5l-.1-.487-.009-.062-.035-.212c-.035-.177-.062-.354-.1-.531-.071-.4-.133-.779-.186-1.16-.044-.319-.089-.62-.124-.929,0-.027-.009-.062-.009-.1-.035-.292-.071-.6-.106-.9A54.442,54.442,0,0,1,33.33,13.3a1.512,1.512,0,0,1,.522-1.142,1.539,1.539,0,0,1,1.16-.363h.035l1.31.133a11.082,11.082,0,0,0,3.063-.177q.226-.053.425-.106c.124-.035.248-.08.372-.124.08-.027.159-.062.23-.089a4.463,4.463,0,0,0,1.142-.69l.372-.319a6.313,6.313,0,0,1,1.6-1.08,9.74,9.74,0,0,1,8.471-.115,6.4,6.4,0,0,1,1.629,1.036l.381.31c1.328,1.062,3.549,1.354,6.586.867a1.528,1.528,0,0,1,1.761,1.469c.1,4.258-.177,14.791-4.815,20.748h0c-5.187,6.665-8.621,6.931-9.347,6.9h-.159ZM34.631,20.022c.044.319.08.628.124.938.053.372.115.744.177,1.124.035.186.062.363.1.54l.142.735c.035.159.062.319.1.487l.159.7c.044.195.089.372.133.549l.274,1.044c.124.416.248.832.381,1.239l.08.23a23.227,23.227,0,0,0,1.23,2.948l.266.5A14.9,14.9,0,0,0,39.349,33.4c5.284,6.417,8.462,6.347,8.807,6.32h.062c.345.027,3.532,0,8.639-6.55,4.585-5.9,4.7-16.942,4.629-20.182a.643.643,0,0,0-.744-.62c-3.293.531-5.736.177-7.276-1.053l-.389-.319a5.406,5.406,0,0,0-1.461-.929,8.879,8.879,0,0,0-7.692.106,5.579,5.579,0,0,0-1.434.965l-.381.328a5.187,5.187,0,0,1-1.372.823l-.266.106c-.142.053-.283.1-.434.142s-.31.089-.478.124a12.251,12.251,0,0,1-3.319.195h-.106l-.221-.027a1.873,1.873,0,0,1-.212-.018l-.77-.089h-.053a.619.619,0,0,0-.5.15.627.627,0,0,0-.221.478,55.144,55.144,0,0,0,.328,5.736c.035.3.062.6.106.9l-.425.133.434-.071ZM57.22,33.414Z",
    transform: "translate(-33.33 -8.319)",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1139",
    "data-name": "Group 1139",
    transform: "translate(0 0.071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1122",
    "data-name": "Group 1122",
    transform: "translate(138.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1112",
    "data-name": "Group 1112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1099",
    "data-name": "Group 1099",
    transform: "translate(6.276 0.319)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 67.369,
    height: 130.852,
    rx: 7.65,
    transform: "translate(0.372 0.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17570",
    "data-name": "Path 17570",
    d: "M224.139,132.045H170.313a7.151,7.151,0,0,1-7.143-7.143V7.583A7.151,7.151,0,0,1,170.313.44h53.826a7.151,7.151,0,0,1,7.143,7.143V124.9a7.151,7.151,0,0,1-7.143,7.143ZM170.3,1.184a6.409,6.409,0,0,0-6.4,6.4V124.9a6.409,6.409,0,0,0,6.4,6.4h53.826a6.409,6.409,0,0,0,6.4-6.4V7.583a6.409,6.409,0,0,0-6.4-6.4H170.3Z",
    transform: "translate(-163.17 -0.44)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1104",
    "data-name": "Group 1104",
    transform: "translate(0.381 0.372)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1101",
    "data-name": "Group 1101",
    transform: "translate(0.319 0.319)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 67.369,
    height: 130.852,
    rx: 7.65,
    fill: "#95b8d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1103",
    "data-name": "Group 1103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17571",
    "data-name": "Path 17571",
    d: "M217.249,132H163.777a7.278,7.278,0,0,1-7.267-7.267V7.767A7.278,7.278,0,0,1,163.777.5h53.472a7.278,7.278,0,0,1,7.267,7.267V124.731A7.278,7.278,0,0,1,217.249,132ZM163.777,1.146a6.628,6.628,0,0,0-6.621,6.621V124.731a6.628,6.628,0,0,0,6.621,6.621h53.472a6.628,6.628,0,0,0,6.621-6.621V7.767a6.628,6.628,0,0,0-6.621-6.621Z",
    transform: "translate(-156.51 -0.5)",
    fill: "#95b8d1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1102",
    "data-name": "Group 1102",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    width: 69.042,
    height: 131.003,
    transform: "translate(-0.673 0.513)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAACUCAYAAAA9Dx9UAAAACXBIWXMAAAsSAAALEgHS3X78AAABN0lEQVR4nO3QUQGAIBQAsSdJDG9DA0AG7nuLsOf9/j1cW8oacZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4YmYO+hwD3kaLm0MAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 69.042,
    height: 131.888,
    transform: "translate(-0.673 -0.372)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAACVCAYAAAD2U8zxAAAACXBIWXMAAAsSAAALEgHS3X78AAABOUlEQVR4nO3QUQGAIBQAsSdJDG9DA0AG7nuLsOf9/j1cW8oacZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwxMwe3RwPgaouSqwAAAABJRU5ErkJggg=="
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 62.147,
    height: 121.85,
    rx: 7.09,
    transform: "translate(3.47 7.179)",
    fill: "#0d3b66"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1106",
    "data-name": "Group 1106",
    transform: "translate(69.971 18.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17573",
    "data-name": "Path 17573",
    d: "M237.715,22.6v11.25H235.13V22.6a1.288,1.288,0,0,1,1.292-1.292,1.263,1.263,0,0,1,.912.381,1.3,1.3,0,0,1,.381.912Z",
    transform: "translate(-235.13 -21.31)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1105",
    "data-name": "Group 1105",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 3.541,
    height: 13.277,
    transform: "translate(-0.336 -0.204)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAPCAYAAADDNm69AAAACXBIWXMAAAsSAAALEgHS3X78AAAAGElEQVQImWNk5RX6z4AEmJA5w1uAgYEBAC2LAUEZ3PbnAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1108",
    "data-name": "Group 1108",
    transform: "translate(69.971 33.406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17575",
    "data-name": "Path 17575",
    d: "M235.13,37.82h2.585V52.434a1.292,1.292,0,0,1-2.585,0V37.82Z",
    transform: "translate(-235.13 -37.82)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1107",
    "data-name": "Group 1107",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 3.541,
    height: 16.818,
    transform: "translate(-0.336 -0.655)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAATCAYAAAC3IqxdAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGklEQVQYlWNk5RX6z4AEmBjQwKgAPgEGBgYAhCMBSfw9dIsAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1110",
    "data-name": "Group 1110",
    transform: "translate(70.007 58.102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17577",
    "data-name": "Path 17577",
    d: "M236.462,88.088h0A1.288,1.288,0,0,1,235.17,86.8V67.012a1.288,1.288,0,0,1,1.292-1.292h0a1.288,1.288,0,0,1,1.292,1.292V86.8A1.288,1.288,0,0,1,236.462,88.088Z",
    transform: "translate(-235.17 -65.72)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1109",
    "data-name": "Group 1109",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    width: 3.541,
    height: 23.014,
    transform: "translate(-0.372 -0.566)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAaCAYAAACQLf2VAAAACXBIWXMAAAsSAAALEgHS3X78AAAAG0lEQVQYlWNk5RX6z4AEmBjQwKjAIBRgYGAAACDZAVcMSgGDAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_17579",
    "data-name": "Path 17579",
    d: "M195.389,4.559a2.009,2.009,0,1,1-2.009-2.009A2.013,2.013,0,0,1,195.389,4.559Z",
    transform: "translate(-160.133 -0.364)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17580",
    "data-name": "Path 17580",
    d: "M222.481,13.721v2.186H159.75V13.721a5.855,5.855,0,0,1,5.842-5.851H216.63a5.857,5.857,0,0,1,5.851,5.851Z",
    transform: "translate(-156.501 -0.975)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17581",
    "data-name": "Path 17581",
    d: "M210.75,13.2V11.369a1.088,1.088,0,0,1,1.089-1.089h7.338a1.088,1.088,0,0,1,1.089,1.089V13.2a1.088,1.088,0,0,1-1.089,1.089h-7.338A1.088,1.088,0,0,1,210.75,13.2Zm1.089-2.328a.5.5,0,0,0-.5.5V13.2a.5.5,0,0,0,.5.5h7.338a.5.5,0,0,0,.5-.5V11.369a.5.5,0,0,0-.5-.5Z",
    transform: "translate(-162.359 -1.251)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17582",
    "data-name": "Path 17582",
    d: "M220.585,11.407v1.832a.793.793,0,0,1-.8.8H216.08V10.61h3.709a.793.793,0,0,1,.8.8Z",
    transform: "translate(-162.971 -1.289)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1111",
    "data-name": "Group 1111",
    transform: "translate(8.887 8.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17583",
    "data-name": "Path 17583",
    d: "M167.822,9.636v5.028a.426.426,0,0,1-.133.266h-.956a.426.426,0,0,1-.133-.266V9.636a.416.416,0,0,1,.416-.416h.4a.416.416,0,0,1,.416.416Z",
    transform: "translate(-166.175 -9.22)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17584",
    "data-name": "Path 17584",
    d: "M170.412,10.278v4.452a.361.361,0,0,1-.124.266h-.974a.416.416,0,0,1-.124-.266V10.278a.4.4,0,0,1,.4-.4h.443a.4.4,0,0,1,.4.4Z",
    transform: "translate(-166.473 -9.296)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17585",
    "data-name": "Path 17585",
    d: "M173,10.862V14.81a.353.353,0,0,1-.115.266h-1a.368.368,0,0,1-.115-.266V10.862a.374.374,0,0,1,.372-.372h.478a.374.374,0,0,1,.372.372Z",
    transform: "translate(-166.769 -9.366)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 6.506,
    height: 0.266,
    transform: "translate(0 5.435)",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17586",
    "data-name": "Path 17586",
    d: "M217.2,132.322H163.728a7.654,7.654,0,0,1-7.648-7.639V12.534a.372.372,0,1,1,.744,0V124.683a6.9,6.9,0,0,0,6.9,6.9h53.472a6.9,6.9,0,0,0,6.9-6.9V7.719a6.9,6.9,0,0,0-6.9-6.9H163.719a.372.372,0,1,1,0-.744h53.472a7.655,7.655,0,0,1,7.648,7.648V124.683a7.648,7.648,0,0,1-7.648,7.639Z",
    transform: "translate(-156.08 -0.08)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17587",
    "data-name": "Path 17587",
    d: "M215.832,130.364h-49.6a6.656,6.656,0,0,1-6.648-6.648V14.418a6.656,6.656,0,0,1,6.648-6.648h49.6a6.656,6.656,0,0,1,6.648,6.648v92.968a.372.372,0,0,1-.744,0V14.418a5.908,5.908,0,0,0-5.9-5.9h-49.6a5.908,5.908,0,0,0-5.9,5.9v109.3a5.908,5.908,0,0,0,5.9,5.9h49.6a.372.372,0,0,1,0,.744Z",
    transform: "translate(-156.482 -0.963)",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17588",
    "data-name": "Path 17588",
    d: "M195.295,122.224h0a4.123,4.123,0,0,0,4.125-4.125V68.185a4.123,4.123,0,0,0-4.125-4.125h0a4.123,4.123,0,0,0-4.125,4.125V118.1A4.123,4.123,0,0,0,195.295,122.224Z",
    transform: "translate(-160.11 -7.428)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 48.294,
    height: 3.806,
    transform: "translate(58.518 22.076) rotate(180)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1121",
    "data-name": "Group 1121",
    transform: "translate(10.71 18.571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1113",
    "data-name": "Group 1113"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 46.586,
    height: 34.415,
    transform: "translate(46.949 34.787) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17589",
    "data-name": "Path 17589",
    d: "M215.137,56.218H168.552a.374.374,0,0,1-.372-.372V21.432a.374.374,0,0,1,.372-.372h46.586a.374.374,0,0,1,.372.372V55.847A.374.374,0,0,1,215.137,56.218Zm-46.214-.744h45.842V21.8H168.924Z",
    transform: "translate(-168.18 -21.06)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1120",
    "data-name": "Group 1120",
    transform: "translate(6.674 3.948)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 30.741,
    height: 0.664,
    transform: "translate(32.432 0.664) rotate(180)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 34.123,
    height: 0.664,
    transform: "translate(34.123 22.678) rotate(180)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1114",
    "data-name": "Group 1114",
    transform: "translate(1.345 17.606)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 11.082,
    height: 0.788,
    transform: "translate(31.919 0.788) rotate(180)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 6.532,
    height: 0.788,
    transform: "translate(6.532 0.788) rotate(180)",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1115",
    "data-name": "Group 1115",
    transform: "translate(1.744 5.037)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 12.799,
    height: 0.788,
    transform: "translate(31.529 0.788) rotate(180)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    width: 5.736,
    height: 0.788,
    transform: "translate(5.736 0.788) rotate(180)",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1116",
    "data-name": "Group 1116",
    transform: "translate(2.894 7.559)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 11.082,
    height: 0.788,
    transform: "translate(30.37 0.788) rotate(180)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    width: 3.434,
    height: 0.788,
    transform: "translate(3.434 0.788) rotate(180)",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    width: 11.082,
    height: 0.788,
    transform: "translate(33.264 27.909) rotate(180)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99",
    "data-name": "Rectangle 99",
    width: 3.434,
    height: 0.788,
    transform: "translate(6.231 27.989) rotate(180)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1117",
    "data-name": "Group 1117",
    transform: "translate(1.416 10.073)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 14.118,
    height: 0.788,
    transform: "translate(31.857 0.788) rotate(180)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101",
    "data-name": "Rectangle 101",
    width: 6.4,
    height: 0.788,
    transform: "translate(6.4 0.788) rotate(180)",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1118",
    "data-name": "Group 1118",
    transform: "translate(3.293 12.578)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 9.232,
    height: 0.788,
    transform: "translate(29.98 0.788) rotate(180)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    width: 2.638,
    height: 0.788,
    transform: "translate(2.638 0.788) rotate(180)",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1119",
    "data-name": "Group 1119",
    transform: "translate(2.337 15.092)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 13.127,
    height: 0.788,
    transform: "translate(30.927 0.788) rotate(180)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 4.55,
    height: 0.788,
    transform: "translate(4.55 0.788) rotate(180)",
    fill: "#060e12"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "man_1",
    transform: "translate(34.441 0.071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1138",
    "data-name": "Group 1138",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "man_2",
    transform: "translate(7.276 5.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17590",
    "data-name": "Path 17590",
    d: "M117.72,45.739c5.922,2.372,9.808,5.745,14.357,11.312,4.47,5.461,5.984,12.313,7.453,14.4,3.479-1.487.389.6,5.461-2.983,8.94.5,14.9,0,22.846.5-1.292,2.275-6.276,7.4-9.931,10.427-1.859,1.54-13.41,8.444-20.359,6.453-9.914-2.832-9.931-11.418-12.392-17.641-.531-1.337-1.283-2.735-4.47-9.577h0l-2.965-12.9Z",
    transform: "translate(-55.237 -11.357)",
    fill: "#cc745f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1123",
    "data-name": "Group 1123",
    transform: "translate(87.112 44.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17591",
    "data-name": "Path 17591",
    d: "M170.861,62.347c-1.16-.283-12.144.443-19.013.938a36.063,36.063,0,0,0-2.956-4.541c-.956-.956-2.558-2.4-2.877.159a19.742,19.742,0,0,0,.425,4.78h-.106s2.558,13.091,5.585,16.924,16.119,3.514,17.561.159,3.08-18.013,1.381-18.42Z",
    transform: "translate(-145.594 -57.084)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17592",
    "data-name": "Path 17592",
    d: "M161.146,83.7c-3.93,0-8.011-.938-9.569-2.912-3.054-3.859-5.559-16.544-5.665-17.083a.371.371,0,0,1,.053-.274,18.427,18.427,0,0,1-.381-4.629c.124-.974.434-1.531.956-1.708.8-.274,1.7.478,2.549,1.328a32.864,32.864,0,0,1,2.894,4.417c8.046-.575,17.756-1.186,18.9-.912h0a.893.893,0,0,1,.575.522c1.23,2.461-.381,15.331-1.7,18.411-.752,1.753-3.833,2.408-5.6,2.647a22.4,22.4,0,0,1-3.027.195ZM146.7,63.82c.381,1.859,2.753,13.083,5.461,16.5,1.779,2.248,7.568,3.027,11.905,2.443,2.709-.363,4.585-1.186,5.019-2.2,1.567-3.656,2.8-17.2,1.629-17.916-.85-.195-7.727.15-18.9.947a.369.369,0,0,1-.345-.186,33.845,33.845,0,0,0-2.894-4.47c-.867-.876-1.469-1.257-1.779-1.151-.212.071-.381.469-.46,1.1a19.052,19.052,0,0,0,.416,4.674.357.357,0,0,1-.053.266Z",
    transform: "translate(-145.544 -57.035)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17593",
    "data-name": "Path 17593",
    d: "M144.67,86.043l.513.168c.345-1.036.2-5.559.044-8.931-.168.248-.336.5-.5.744a.08.08,0,0,0-.009-.044c.15,3.39.239,7.205-.044,8.055Z",
    transform: "translate(-58.332 -14.98)",
    fill: "#252122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17594",
    "data-name": "Path 17594",
    d: "M128.245,116.24c.8,7.471,1.877,19.022,2.532,33.184.23,4.983.4,12.074.292,25.643-.133,16.836-.744,46.09-3.78,84.957-.434,5.55-.841,10.33-1.16,13.985a3.5,3.5,0,0,1-3.488,3.2H107.214a3.5,3.5,0,0,1-3.5-3.417c-.159-6.869-.354-16.26-.558-27.387-.257-14-.4-24.227-.443-27.944-.2-14.154-.584-36.336-1.407-70.936q-1.049,24.444-2.2,48.878-1.832,38.517-3.974,77.035a3.492,3.492,0,0,1-3.408,3.3L77,277.108a3.506,3.506,0,0,1-3.585-3.284C72.649,261.1,72.242,250.6,72,243.215c-1.266-39.894.566-52.844.726-88.5a198.915,198.915,0,0,1,1.4-26.732l1.195-9.586,52.923-2.142Z",
    transform: "translate(-49.936 -19.455)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17595",
    "data-name": "Path 17595",
    d: "M75.74,110.1c4.5,1.142,8.586,1.965,12.3,2.532,11.657,1.779,19.642,1.044,25.13-.221l15.694-3.833s-.248-1.266-.628-3.213-.894-4.585-1.425-7.311c-1.5-7.745-2.257-11.613-2.5-12.959-2.08-11.534-1.283-14.809-3.771-26.661-.974-4.612-1.735-7.2-3.895-9.648a15.13,15.13,0,0,0-4.479-3.47c-.195-.1-.381-.195-.575-.283h0a20.723,20.723,0,0,0-5.506-1.664l-9.808,1.115-.717.08-.54.062-2.116.239L84.4,59.1l-3.8,6.347c-.044.407-.089.805-.133,1.213Q78.1,88.38,75.74,110.111Z",
    transform: "translate(-50.416 -11.086)",
    fill: "#cc745f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17596",
    "data-name": "Path 17596",
    d: "M100.937,115.965a87,87,0,0,1-12.994-1.053c-3.877-.593-8.028-1.443-12.339-2.54a.361.361,0,0,1-.274-.4l4.727-43.452a.369.369,0,1,1,.735.08L76.1,111.734c4.178,1.053,8.2,1.877,11.958,2.443,9.613,1.469,18.022,1.39,25-.221l15.34-3.753-.558-2.868c-.381-1.947-.894-4.585-1.425-7.311l-.133-.69c-1.416-7.3-2.133-10.967-2.363-12.268-.956-5.3-1.31-8.86-1.646-12.295a115.44,115.44,0,0,0-2.124-14.348.375.375,0,0,1,.735-.15A117.434,117.434,0,0,1,123.022,74.7c.336,3.426.682,6.975,1.638,12.242.23,1.3.947,4.957,2.363,12.259l.133.69c.531,2.735,1.044,5.364,1.425,7.311l.628,3.213a.371.371,0,0,1-.274.434l-15.694,3.833a54.575,54.575,0,0,1-12.277,1.283Z",
    transform: "translate(-50.369 -12.992)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1124",
    "data-name": "Group 1124",
    transform: "translate(32.838 67.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17597",
    "data-name": "Path 17597",
    d: "M84.64,88.388a27.446,27.446,0,0,1,3.7-2.2c2.452-1.213,6.125-3.027,7.71-1.629a2.278,2.278,0,0,1,.69,1.62c-.018.947-.752,1.461-3.107,3.488s-2.408,2.186-3.045,2.425c-.54.2-2.709,1.036-4.408-.23a4.379,4.379,0,0,1-1.54-3.47Z",
    transform: "translate(-84.276 -83.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17598",
    "data-name": "Path 17598",
    d: "M88.328,92.88a3.943,3.943,0,0,1-2.408-.761,4.779,4.779,0,0,1-1.691-3.78.382.382,0,0,1,.159-.3,27.955,27.955,0,0,1,3.753-2.231c2.673-1.319,6.347-3.133,8.117-1.576a2.644,2.644,0,0,1,.814,1.9c-.018,1.018-.655,1.558-2.54,3.169l-.69.593c-.628.54-1.089.947-1.443,1.257a5.158,5.158,0,0,1-1.708,1.239,6.6,6.6,0,0,1-2.346.487Zm-3.355-4.346a3.921,3.921,0,0,0,1.39,2.983c.7.522,1.965.983,4.045.186.4-.15.5-.239,1.487-1.106.354-.31.823-.717,1.452-1.257l.69-.593c1.8-1.531,2.266-1.965,2.284-2.62a1.959,1.959,0,0,0-.558-1.328c-1.4-1.23-5.09.593-7.294,1.682a27.939,27.939,0,0,0-3.488,2.054Z",
    transform: "translate(-84.229 -83.632)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1125",
    "data-name": "Group 1125",
    transform: "translate(47.099 16.192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17599",
    "data-name": "Path 17599",
    d: "M100.76,25.61V44.1a6.163,6.163,0,0,0,3.886,3.381,7.655,7.655,0,0,0,2.709.071,8.2,8.2,0,0,0,2.425-.726c.62-.912,1.239-1.815,1.859-2.726V25.61H100.76Z",
    transform: "translate(-100.388 -25.238)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17600",
    "data-name": "Path 17600",
    d: "M106.076,47.974a6.782,6.782,0,0,1-1.567-.168,6.5,6.5,0,0,1-4.134-3.594.347.347,0,0,1-.035-.159V25.562a.374.374,0,0,1,.372-.372h10.87a.374.374,0,0,1,.372.372v18.5a.454.454,0,0,1-.062.212L110.032,47a.346.346,0,0,1-.15.124,8.416,8.416,0,0,1-2.54.752,9.961,9.961,0,0,1-1.275.089Zm-4.992-4a5.711,5.711,0,0,0,3.6,3.107,6.887,6.887,0,0,0,2.567.062,8.076,8.076,0,0,0,2.231-.646l1.735-2.549V25.934H101.092V43.973Z",
    transform: "translate(-100.34 -25.19)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17601",
    "data-name": "Path 17601",
    d: "M97.883,20.673a16.71,16.71,0,0,0,3.071,7.568c.239.319.451.575.6.744.4.1.8.2,1.195.3A17.58,17.58,0,0,0,103.495,26c.283-2.284-.062-3.24.142-4.072.345-1.452,2.478-3.089,10.463-3.842a6.86,6.86,0,0,0,2.222-.558,7.141,7.141,0,0,0,2.16-1.5,8.693,8.693,0,0,0-1-4.32C115,7.121,109.089,6.9,108.673,6.9a11.3,11.3,0,0,0-10.463,6.648c-1.044,2.514-.682,4.842-.336,7.143Z",
    transform: "translate(-52.918 -6.897)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1126",
    "data-name": "Group 1126",
    transform: "translate(47.755 5.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17602",
    "data-name": "Path 17602",
    d: "M119.277,19.8a21.889,21.889,0,0,0-.381-3.027,5.554,5.554,0,0,0-2.107-2.293,6.476,6.476,0,0,0-5.479-.168,7.833,7.833,0,0,0-2.824,1.832,6.7,6.7,0,0,0-1.992,2.655,2.239,2.239,0,0,1-.717,1.195,2.55,2.55,0,0,1-.69.345,1.8,1.8,0,0,0-.726.628,1.691,1.691,0,0,0-1.239-.469,2.127,2.127,0,0,0-1.54,1.655,3.294,3.294,0,0,0,.823,2.611,5.812,5.812,0,0,0,1.567,1.576c.009.248.027.5.035.77a9.415,9.415,0,0,0,.266,2.5c.655,1.894,2.2,2.868,3.806,3.886,1.947,1.23,3.682,2.328,5.6,1.8a5.387,5.387,0,0,0,2.239-1.5,8.424,8.424,0,0,0,1.877-2.709c.469-1.071.522-1.744.814-4.169.584-4.815.779-5.364.682-7.134Z",
    transform: "translate(-101.133 -13.376)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17603",
    "data-name": "Path 17603",
    d: "M112.614,35.759c-1.646,0-3.187-.974-4.8-1.992s-3.257-2.054-3.965-4.072a9.857,9.857,0,0,1-.283-2.62c0-.195-.018-.389-.027-.584a6.512,6.512,0,0,1-1.514-1.567,3.663,3.663,0,0,1-.876-2.912,2.5,2.5,0,0,1,1.859-1.938,1.9,1.9,0,0,1,1.222.328,2.352,2.352,0,0,1,.628-.46c.053-.027.115-.044.186-.071a1.223,1.223,0,0,0,.434-.23,1.858,1.858,0,0,0,.575-.974,6.963,6.963,0,0,1,2.1-2.859,8.283,8.283,0,0,1,2.956-1.912,6.572,6.572,0,0,1,5.8.195,5.9,5.9,0,0,1,2.248,2.443.317.317,0,0,1,.035.1,21.084,21.084,0,0,1,.389,3.08,18.419,18.419,0,0,1-.292,4.072c-.106.8-.239,1.8-.4,3.133l-.071.584a11.406,11.406,0,0,1-.77,3.691,9.1,9.1,0,0,1-1.956,2.824l-.071.071a5.576,5.576,0,0,1-2.328,1.514,3.951,3.951,0,0,1-1.1.15Zm-9.427-14.941h-.08c-.567.062-1.071.761-1.222,1.372a3.007,3.007,0,0,0,.77,2.319,5.428,5.428,0,0,0,1.469,1.478.361.361,0,0,1,.159.283c.009.248.027.5.035.77a8.951,8.951,0,0,0,.248,2.4c.611,1.77,2.089,2.7,3.656,3.691,1.9,1.2,3.549,2.239,5.3,1.753a4.947,4.947,0,0,0,2.009-1.337l.071-.071a8.219,8.219,0,0,0,1.788-2.585,10.844,10.844,0,0,0,.717-3.479l.071-.584c.159-1.337.292-2.346.4-3.133a18.3,18.3,0,0,0,.283-3.93h0a21.411,21.411,0,0,0-.363-2.921,5.181,5.181,0,0,0-1.938-2.1,5.878,5.878,0,0,0-5.16-.142,7.529,7.529,0,0,0-2.691,1.744,6.508,6.508,0,0,0-1.9,2.5,2.657,2.657,0,0,1-.841,1.381,2.048,2.048,0,0,1-.655.345.642.642,0,0,0-.106.044,1.463,1.463,0,0,0-.584.5.368.368,0,0,1-.549.071,1.449,1.449,0,0,0-.876-.389Z",
    transform: "translate(-101.082 -13.326)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17604",
    "data-name": "Path 17604",
    d: "M117.641,31.757a2.563,2.563,0,0,1,.168.682,4.506,4.506,0,0,1-.089,1.381c-.1.451-.186.9-.328,1.345a3.447,3.447,0,0,1-.673,1.222,2.984,2.984,0,0,1-1.142.805,4.03,4.03,0,0,1-1.372.274c-.23,0-.469,0-.7-.018a3.906,3.906,0,0,1-.7-.1,1.78,1.78,0,0,1-1.089-.885,3.823,3.823,0,0,1-.407-1.345,8.114,8.114,0,0,1-.053-1.39,9.169,9.169,0,0,1,.159-1.381,2.339,2.339,0,0,1,.646-1.239,2.844,2.844,0,0,1,1.248-.611,4.792,4.792,0,0,1,1.372-.23,5.456,5.456,0,0,1,1.372.186,2.506,2.506,0,0,1,1.2.69,2.087,2.087,0,0,1,.372.593Zm-.965-.947a2.606,2.606,0,0,0-.637-.23,4.248,4.248,0,0,0-.673-.1,3.417,3.417,0,0,0-.673,0,4.3,4.3,0,0,0-1.283.336,2.347,2.347,0,0,0-1.027.637,1.926,1.926,0,0,0-.372,1.036c-.009.1-.018.195-.027.3v.328c-.018.221,0,.434,0,.655a7.2,7.2,0,0,0,.124,1.257,3.294,3.294,0,0,0,.336,1.044,1.16,1.16,0,0,0,.257.336.855.855,0,0,0,.328.186,3.775,3.775,0,0,0,.549.106q.305.04.611.053a2.97,2.97,0,0,0,2.2-.673,3.081,3.081,0,0,0,.726-1.018,6.6,6.6,0,0,0,.239-.628c.071-.221.15-.434.2-.655a4.541,4.541,0,0,0,.168-1.337,2.066,2.066,0,0,0-.142-.655,2.117,2.117,0,0,0-.345-.575,1.976,1.976,0,0,0-.531-.407Z",
    transform: "translate(-54.494 -9.582)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17605",
    "data-name": "Path 17605",
    d: "M118.37,24.024a.664.664,0,1,0,.664-.664A.663.663,0,0,0,118.37,24.024Z",
    transform: "translate(-55.312 -8.788)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17606",
    "data-name": "Path 17606",
    d: "M111.9,24.274a.664.664,0,1,0,.664-.664A.663.663,0,0,0,111.9,24.274Z",
    transform: "translate(-54.569 -8.817)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17607",
    "data-name": "Path 17607",
    d: "M106,18.875a.668.668,0,0,1,.655.859,4.347,4.347,0,0,0-.115,2.4c.266.894.478,1.753.611,2.3a.66.66,0,0,1-.443.779h0a.656.656,0,0,1-.832-.407c-.6-1.646-2.257-6.09-2.62-5.966A14.6,14.6,0,0,0,106,18.875Z",
    transform: "translate(-53.572 -8.269)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17608",
    "data-name": "Path 17608",
    d: "M112.72,31.6a2.331,2.331,0,0,0,1.266,2.16,2.5,2.5,0,0,0,3.054-1.938,6.587,6.587,0,0,1-4.32-.212Z",
    transform: "translate(-54.663 -9.734)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17609",
    "data-name": "Path 17609",
    d: "M105.714,50.489a3.451,3.451,0,0,1,2.532-.177,3.394,3.394,0,0,0-.8-2.381c-.142-.159-1.071-1.239-1.912-1.053-1.682.363-1.885,5.488-1.443,5.6.23.062.416-1.328,1.629-1.992Z",
    transform: "translate(-53.649 -11.486)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17610",
    "data-name": "Path 17610",
    d: "M108.986,49.62s2.894-3.257,3.249-2.169.9,4.523.9,4.523c-.761-1.638-1.655-1.921-1.992-1.992a8.075,8.075,0,0,0-2.346.363h0l.177-.726Z",
    transform: "translate(-54.213 -11.529)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1127",
    "data-name": "Group 1127",
    transform: "translate(54.215 29.587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17611",
    "data-name": "Path 17611",
    d: "M108.81,48.875c.239-.336.611-.841,1.08-1.443.974-1.23,1.133-1.275,1.629-1.992a6.823,6.823,0,0,0,1.266-2.709,5.677,5.677,0,0,0,0-1.992,3.3,3.3,0,0,1,1.133.69c.372.354.664.823,1.4,3.284.168.575.257.867.292,1,.487,2.08-1.381,4.718-2.461,6.054-1.142-3.558-1.788-4.4-2.169-4.337-.239.035-.319.416-.9,1.089a6.325,6.325,0,0,1-1.266,1.089v-.726Z",
    transform: "translate(-108.429 -40.371)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17612",
    "data-name": "Path 17612",
    d: "M113.1,52.093h-.071a.369.369,0,0,1-.283-.248c-1.036-3.213-1.567-3.9-1.753-4.054-.035.044-.071.106-.115.168a6.3,6.3,0,0,1-.575.761,6.747,6.747,0,0,1-1.345,1.151.389.389,0,0,1-.381.018.366.366,0,0,1-.195-.327v-.726a.36.36,0,0,1,.071-.212c.354-.5.717-.983,1.1-1.461.469-.593.752-.912.974-1.168a6.564,6.564,0,0,0,.637-.805,6.48,6.48,0,0,0,1.2-2.567,5.047,5.047,0,0,0,0-1.859.381.381,0,0,1,.124-.354.375.375,0,0,1,.372-.062,3.617,3.617,0,0,1,1.257.77c.451.443.779,1.044,1.5,3.443.177.593.266.885.292,1.018.487,2.071-1.106,4.612-2.532,6.373a.374.374,0,0,1-.292.142ZM110.991,47c.469,0,1.08.487,2.239,3.939,1.567-2.08,2.257-3.9,1.956-5.187-.027-.133-.115-.416-.283-.974-.726-2.434-1.009-2.841-1.3-3.125a2.512,2.512,0,0,0-.416-.328,5.91,5.91,0,0,1-.089,1.425,7.169,7.169,0,0,1-1.328,2.859,8.022,8.022,0,0,1-.69.867c-.221.248-.5.558-.947,1.133-.248.319-.5.637-.735.965.115-.115.23-.23.345-.354a5.646,5.646,0,0,0,.513-.682c.168-.257.319-.478.611-.522.035,0,.08-.009.115-.009Z",
    transform: "translate(-108.38 -40.324)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1134",
    "data-name": "Group 1134",
    transform: "translate(43.726 55.59)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1130",
    "data-name": "Group 1130",
    transform: "translate(0.372 0.372)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_106",
    "data-name": "Rectangle 106",
    width: 74.468,
    height: 47.586,
    rx: 6.19,
    fill: "#95b8d1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1129",
    "data-name": "Group 1129"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_107",
    "data-name": "Rectangle 107",
    width: 74.468,
    height: 47.586,
    rx: 6.19,
    fill: "#95b8d1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1128",
    "data-name": "Group 1128",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_108",
    "data-name": "Rectangle 108",
    width: 152.247,
    height: 54.88,
    transform: "translate(-32.043 -3.576)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKwAAAA+CAYAAAC2n/CQAAAACXBIWXMAAAsSAAALEgHS3X78AAABC0lEQVR4nO3csQ3CQBAAQYOc0gOFUR6F0QMFgAQyMXbAe8VMCf7VBf7THyZY6Xy9P379zW6X06vV2WH1jAhmLwS7wT8HM1oyWMH8r03BCoZRZvFRcnRalAiWFMGSIlhSBEuKYEkRLCmCJeW4bMFAgQlLimBJESwpgiVFsKQIlhTBkrDsbQuWFMGSIlhSBEuKYEkRLCmCJUWwpAiWFMGSIlhSBEuKYEkRLCmCJUWwpAiWFMGSIlhSBEuKYEkRLCmCJUWwpLyC9UYsFSYsKYIlRbCkCJYUwZIiWFI+v7OW9zdhz0xYUgRLyuy4KFhuYwXLV/ZyfS/YCPseb4JdQTTjpYIVDKuCFQxDTdP0BK/dIdvju+2oAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    width: 74.468,
    height: 47.586,
    rx: 6.19,
    fill: "#95b8d1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 35.725,
    height: 0.938,
    transform: "translate(38.814 11.843)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17613",
    "data-name": "Path 17613",
    d: "M169.58,75.761A1.761,1.761,0,1,0,171.341,74,1.76,1.76,0,0,0,169.58,75.761Z",
    transform: "translate(-104.919 -70.194)",
    fill: "#0d3b66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17614",
    "data-name": "Path 17614",
    d: "M161.7,75.761A1.761,1.761,0,1,0,163.461,74,1.76,1.76,0,0,0,161.7,75.761Z",
    transform: "translate(-104.014 -70.194)",
    fill: "#0d3b66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17615",
    "data-name": "Path 17615",
    d: "M153.82,75.761A1.761,1.761,0,1,0,155.581,74,1.76,1.76,0,0,0,153.82,75.761Z",
    transform: "translate(-103.109 -70.194)",
    fill: "#0d3b66"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1133",
    "data-name": "Group 1133",
    transform: "translate(5.037 3.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1132",
    "data-name": "Group 1132",
    transform: "translate(0.372 0.372)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 10.693,
    cy: 10.693,
    r: 10.693,
    fill: "#0d3b66"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17616",
    "data-name": "Path 17616",
    d: "M113.284,95.569a11.064,11.064,0,1,1,6.187-20.235.369.369,0,1,1-.416.611,10.323,10.323,0,1,0,4.55,8.559.372.372,0,0,1,.744,0A11.08,11.08,0,0,1,113.284,95.569Z",
    transform: "translate(-102.22 -73.44)",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17617",
    "data-name": "Path 17617",
    d: "M164.743,106.155H108.217a1.947,1.947,0,0,1-1.947-1.947h0a1.947,1.947,0,0,1,1.947-1.947h56.526a1.947,1.947,0,0,1,1.947,1.947h0A1.947,1.947,0,0,1,164.743,106.155Z",
    transform: "translate(-97.649 -73.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17618",
    "data-name": "Path 17618",
    d: "M146.38,117.441H132.235a1.345,1.345,0,0,1-1.345-1.345h0a1.345,1.345,0,0,1,1.345-1.345H146.38a1.345,1.345,0,0,1,1.345,1.345h0A1.345,1.345,0,0,1,146.38,117.441Z",
    transform: "translate(-100.476 -74.874)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17619",
    "data-name": "Path 17619",
    d: "M171,117.441H156.855a1.345,1.345,0,0,1-1.345-1.345h0a1.345,1.345,0,0,1,1.345-1.345H171a1.345,1.345,0,0,1,1.345,1.345h0A1.345,1.345,0,0,1,171,117.441Z",
    transform: "translate(-103.304 -74.874)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17620",
    "data-name": "Path 17620",
    d: "M165.891,118.029h-63.51a5.857,5.857,0,0,1-5.851-5.851V75.551a5.857,5.857,0,0,1,5.851-5.851h63.51a5.857,5.857,0,0,1,5.851,5.851v36.628A5.857,5.857,0,0,1,165.891,118.029Zm-63.51-47.586a5.115,5.115,0,0,0-5.107,5.107v36.628a5.115,5.115,0,0,0,5.107,5.107h63.51A5.115,5.115,0,0,0,171,112.179V75.551a5.115,5.115,0,0,0-5.107-5.107h-63.51Z",
    transform: "translate(-96.53 -69.7)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17621",
    "data-name": "Path 17621",
    d: "M164.7,106.478H108.169a2.321,2.321,0,0,1-2.319-2.319.372.372,0,1,1,.744,0,1.579,1.579,0,0,0,1.576,1.576H164.7a1.576,1.576,0,1,0,0-3.151h-4.461a.372.372,0,1,1,0-.744H164.7a2.319,2.319,0,0,1,0,4.638Z",
    transform: "translate(-97.6 -73.391)",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1135",
    "data-name": "Group 1135",
    transform: "translate(17.251 72.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17622",
    "data-name": "Path 17622",
    d: "M69.253,105.446c1.283,1.275,3.682,3.2,11.126,5.435,2.239.673,5.665,1.168,12.516,2.16.566.08,5.037.62,6.32-.947a3.173,3.173,0,0,0,.628-1.4,5.686,5.686,0,0,0-.018-2.018c-.027-.15-.053-.283-.08-.416,0-.027-.018-.062-.018-.089,2.532.027,3.709-.947,3.8-3.24a1.969,1.969,0,0,0-.859-1.956,2,2,0,0,0-.832-.266,6.427,6.427,0,0,0,1.434-.142,3.271,3.271,0,0,0,2.832-3.01c.195-2.275-1.9-3.01-3.346-3.249a7.852,7.852,0,0,0-1.292-.106,7.5,7.5,0,0,0,1.168-.221c1.469-.372,3.709-1.345,2.877-3.682-1.036-2.93-10.471-2.9-13.038-2.841-.407.009-.646.018-.646.018l-.611-.027-8.595-.372h-.062c-2.974-.133-5.948-.257-8.914-.389.274,4.479-.929,6.94-2.2,8.374-1.788,2.018-4.089,2.416-4.373,4.3-.071.478-.124,1.779,2.186,4.081Z",
    transform: "translate(-66.668 -88.327)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17623",
    "data-name": "Path 17623",
    d: "M95.193,113.525a17.36,17.36,0,0,1-2.4-.168c-6.878-.991-10.312-1.487-12.578-2.169-7.267-2.186-9.843-4.1-11.277-5.523h0c-1.708-1.7-2.478-3.178-2.293-4.4.195-1.275,1.151-1.93,2.266-2.682a11.307,11.307,0,0,0,2.2-1.806c1.62-1.815,2.328-4.541,2.107-8.1a.4.4,0,0,1,.106-.283.374.374,0,0,1,.283-.115c2.974.133,5.948.257,8.914.389H82.6l9.2.4s.239-.009.62-.018c3.673-.08,12.321.044,13.4,3.089a2.7,2.7,0,0,1-.08,2.231,4.036,4.036,0,0,1-2.239,1.691c2.045.531,3.08,1.753,2.93,3.5a3.626,3.626,0,0,1-3.125,3.337.467.467,0,0,0-.106.027,2.544,2.544,0,0,1,.655,1.992c-.089,2.346-1.275,3.5-3.709,3.594a.2.2,0,0,0,.009.071,6.068,6.068,0,0,1,.018,2.151,3.458,3.458,0,0,1-.708,1.558c-.823,1.009-2.7,1.239-4.258,1.239ZM69.47,105.133c1.372,1.363,3.859,3.2,10.967,5.337,2.2.664,5.63,1.16,12.436,2.142,1.345.195,5,.416,6-.805a2.618,2.618,0,0,0,.549-1.23,5.411,5.411,0,0,0-.018-1.885c-.027-.142-.053-.274-.08-.389a.518.518,0,0,1,.062-.363.46.46,0,0,1,.283-.186c2.346.018,3.337-.814,3.417-2.886a1.64,1.64,0,0,0-.682-1.62,1.612,1.612,0,0,0-.673-.212.365.365,0,0,1-.336-.389.372.372,0,0,1,.381-.354,6.364,6.364,0,0,0,1.345-.133,2.874,2.874,0,0,0,2.549-2.673c.168-1.921-1.558-2.6-3.036-2.841a8.131,8.131,0,0,0-1.23-.106h0a.375.375,0,0,1-.372-.345.371.371,0,0,1,.319-.4,8.238,8.238,0,0,0,1.133-.212,4.048,4.048,0,0,0,2.576-1.567,1.953,1.953,0,0,0,.035-1.629c-.752-2.116-7.3-2.726-12.675-2.593-.4.009-.637.018-.637.018l-9.232-.4h-.089l-8.48-.372c.15,3.558-.628,6.329-2.319,8.232a11.958,11.958,0,0,1-2.337,1.93c-1.009.682-1.8,1.222-1.947,2.177s.575,2.266,2.089,3.762Z",
    transform: "translate(-66.619 -88.28)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17624",
    "data-name": "Path 17624",
    d: "M47.921,86.067c1.478,4.4,8.055,9.445,10.117,11.029a45.75,45.75,0,0,0,9.622,5.647l.5.212a45.892,45.892,0,0,0,4.877,1.735q3.89-11.843,7.772-23.678c-1.531-.62-3.071-1.239-4.6-1.859-.168-.071-.336-.133-.5-.2-1.735-.7-3.461-1.4-5.2-2.1l.062-.062c.168-.168.425-.416.744-.744,2.886-2.9,11.4-11.6,16.721-18.721,1.443-1.93,3.443-4.789,3.071-8.312a9.064,9.064,0,0,0-1.443-3.974C61.6,59.477,44.752,76.613,47.921,86.076Z",
    transform: "translate(-47.178 -11.278)",
    fill: "#cc745f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1136",
    "data-name": "Group 1136",
    transform: "translate(44.284 26.701)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17625",
    "data-name": "Path 17625",
    d: "M106.98,48.687c-.044-.142-.832-2.558-1.806-2.532-.947.027-1.691,2.337-1.992,3.257a11.387,11.387,0,0,0-.363,1.443,9.018,9.018,0,0,1-2.169-1.443A10.026,10.026,0,0,1,97.58,43.27a20.532,20.532,0,0,1,2.894-5.78,6.834,6.834,0,0,0,1.629,4.7c1.2,1.292,2.47,1.292,3.611,2.709a6.306,6.306,0,0,1,1.266,3.8Z",
    transform: "translate(-97.208 -37.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17626",
    "data-name": "Path 17626",
    d: "M102.772,51.179a.347.347,0,0,1-.159-.035,9.387,9.387,0,0,1-2.257-1.5,10.451,10.451,0,0,1-3.2-6.373.49.49,0,0,1,.018-.159,20.5,20.5,0,0,1,.921-2.39,20.888,20.888,0,0,1,2.027-3.5.37.37,0,0,1,.407-.142.381.381,0,0,1,.266.345,6.7,6.7,0,0,0,1.522,4.461,6.1,6.1,0,0,0,1.629,1.177,6.073,6.073,0,0,1,2,1.558,6.6,6.6,0,0,1,1.345,4.019.381.381,0,0,1-.31.381.373.373,0,0,1-.416-.257c-.345-1.106-1.018-2.266-1.443-2.275-.257,0-.814.407-1.646,2.992a9.773,9.773,0,0,0-.345,1.4.377.377,0,0,1-.195.266.4.4,0,0,1-.168.044Zm-4.859-7.931a9.65,9.65,0,0,0,2.939,5.833,8.451,8.451,0,0,0,1.655,1.168c.08-.336.168-.673.274-1.009.549-1.717,1.266-3.479,2.328-3.514a1.275,1.275,0,0,1,.921.434,5.156,5.156,0,0,0-.655-1.089A5.36,5.36,0,0,0,103.6,43.7a6.067,6.067,0,0,1-3.461-5.178,20.655,20.655,0,0,0-1.363,2.5,19.349,19.349,0,0,0-.859,2.231Z",
    transform: "translate(-97.16 -37.063)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1137",
    "data-name": "Group 1137",
    transform: "translate(90.847 45.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17627",
    "data-name": "Path 17627",
    d: "M170.6,70.121c-.319.478-.85,1.275-1.593,1.275a1.791,1.791,0,0,1-1.4-.947,4.042,4.042,0,0,1-.513-1.133,3.681,3.681,0,0,1-.15.575,3.481,3.481,0,0,1-1.443,1.868,2.754,2.754,0,0,1-2.239.434,2.351,2.351,0,0,1-1.133-.761,2.442,2.442,0,0,1-.248-.345,2.883,2.883,0,0,1-.372-.965,5.949,5.949,0,0,1-.257.69,4.481,4.481,0,0,1-1.337,1.859,3.047,3.047,0,0,1-2.717.319,3.163,3.163,0,0,1-1.779-1.7,3.666,3.666,0,0,1-.3-1.168c-.106.177-.2.345-.292.487a4,4,0,0,1-.664.947c-1,.752-2.443-.1-2.558-.159-1.7-.956-1.841-4.78-.637-9.418a2.61,2.61,0,0,1,4.6-1.5c.062.071.124.142.186.221a5.248,5.248,0,0,1,.469-.443,4.231,4.231,0,0,1,5.2-.186,4.887,4.887,0,0,1,.389.31c.035-.035.115-.124.248-.239a2.794,2.794,0,0,1,4.461,1.027,1.365,1.365,0,0,1,.071.168,2.766,2.766,0,0,1,.531-.885,2.2,2.2,0,0,1,.744-.549,2.7,2.7,0,0,1,2.877.637c.425.425.628.947.637,4.151.009,3.656-.248,4.594-.8,5.426Z",
    transform: "translate(-149.813 -58.897)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17628",
    "data-name": "Path 17628",
    d: "M158.2,73.5a3.58,3.58,0,0,1-1.177-.2,3.474,3.474,0,0,1-1.992-1.9c-.044-.106-.089-.212-.124-.319a2.822,2.822,0,0,1-.566.735c-1.089.814-2.532.106-2.948-.124-1.815-1.027-2.133-4.78-.832-9.816a3.033,3.033,0,0,1,1.841-2.514,3.068,3.068,0,0,1,3.337.761l.212-.186a4.592,4.592,0,0,1,5.656-.2.965.965,0,0,1,.15.115c.009,0,.018-.018.027-.027a3.152,3.152,0,0,1,4.78.673,2.76,2.76,0,0,1,.257-.328,2.534,2.534,0,0,1,.867-.637,3.038,3.038,0,0,1,3.293.717c.549.558.735,1.266.744,4.417.009,3.691-.257,4.727-.859,5.63h0c-.336.5-.956,1.443-1.9,1.443a2.091,2.091,0,0,1-1.708-1.106c-.053-.08-.106-.168-.159-.257a3.78,3.78,0,0,1-1.443,1.682,3.1,3.1,0,0,1-2.549.469,2.756,2.756,0,0,1-1.31-.876,3.233,3.233,0,0,1-.283-.4c-.018-.035-.044-.071-.062-.106a4.688,4.688,0,0,1-1.372,1.815,3.261,3.261,0,0,1-1.877.566Zm-3.125-3.8a.342.342,0,0,1,.08.009.359.359,0,0,1,.283.336A3.027,3.027,0,0,0,155.7,71.1a2.751,2.751,0,0,0,1.567,1.5,2.68,2.68,0,0,0,2.372-.274,4.144,4.144,0,0,0,1.213-1.7q.133-.319.239-.637a.564.564,0,0,0,.018-.062.369.369,0,0,1,.381-.221.376.376,0,0,1,.327.292,2.687,2.687,0,0,0,.328.841,2.6,2.6,0,0,0,.212.3,2.029,2.029,0,0,0,.956.646,2.4,2.4,0,0,0,1.939-.389,3.165,3.165,0,0,0,1.283-1.673,3.988,3.988,0,0,0,.133-.513.367.367,0,0,1,.345-.3.372.372,0,0,1,.372.266,3.778,3.778,0,0,0,.469,1.027,1.471,1.471,0,0,0,1.089.779h0c.549,0,1.009-.7,1.283-1.106h0c.513-.779.744-1.717.735-5.222-.009-3.133-.212-3.576-.531-3.886a2.322,2.322,0,0,0-2.461-.566,1.829,1.829,0,0,0-.62.46,2.29,2.29,0,0,0-.46.77.4.4,0,0,1-.345.248.369.369,0,0,1-.354-.239.984.984,0,0,0-.062-.142,2.524,2.524,0,0,0-2.16-1.531,2.57,2.57,0,0,0-1.726.628c-.115.1-.186.168-.221.2a.386.386,0,0,1-.531.027c-.062-.053-.177-.159-.345-.283a3.85,3.85,0,0,0-4.762.168,3.735,3.735,0,0,0-.425.4.37.37,0,0,1-.292.124.365.365,0,0,1-.283-.15c-.053-.071-.106-.133-.159-.195a2.337,2.337,0,0,0-2.576-.646,2.288,2.288,0,0,0-1.381,1.93.112.112,0,0,1-.009.053c-1.186,4.559-1,8.179.46,9,.328.186,1.416.735,2.151.186a5.725,5.725,0,0,0,.566-.841c.089-.142.186-.31.292-.487a.383.383,0,0,1,.319-.186Z",
    transform: "translate(-149.765 -58.85)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17629",
    "data-name": "Path 17629",
    d: "M110.292,22.24a.37.37,0,0,1-.336-.212.38.38,0,0,1,.177-.5,7.768,7.768,0,0,1,4.3-.575.365.365,0,0,1,.292.434.36.36,0,0,1-.434.292,7.087,7.087,0,0,0-3.842.522.347.347,0,0,1-.159.035Z",
    transform: "translate(-54.342 -8.5)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17630",
    "data-name": "Path 17630",
    d: "M121.085,22.259a.377.377,0,0,1-.274-.124,4.864,4.864,0,0,0-3.532-.469.373.373,0,0,1-.2-.717c1.469-.416,3.7.044,4.284.69a.366.366,0,0,1-.027.522.38.38,0,0,1-.248.1Z",
    transform: "translate(-55.132 -8.493)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17631",
    "data-name": "Path 17631",
    d: "M117.222,29.373a3.756,3.756,0,0,1-1.629-.407.374.374,0,0,1,.345-.664,2.469,2.469,0,0,0,1.7.257c.106-.044.124-.089.124-.106.124-.407-.124-1.974-1.691-4.01a.373.373,0,0,1,.593-.451c1.6,2.08,2.062,3.886,1.815,4.691a.914.914,0,0,1-.549.566,1.759,1.759,0,0,1-.7.124Z",
    transform: "translate(-54.97 -8.843)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17632",
    "data-name": "Path 17632",
    d: "M103.792,26.062a.379.379,0,0,1-.195-.053,2.25,2.25,0,0,1-1.062-3.08,1.237,1.237,0,0,1,1.7-.549.373.373,0,1,1-.389.637c-.283-.168-.558.106-.682.3-.328.549-.221,1.425.814,2.054a.372.372,0,0,1-.195.69Z",
    transform: "translate(-53.462 -8.657)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17633",
    "data-name": "Path 17633",
    d: "M72.994,107.109a.312.312,0,0,1-.106-.018,48.959,48.959,0,0,1-4.913-1.744c-.15-.062-.31-.133-.469-.2a46.067,46.067,0,0,1-9.737-5.709c-2.16-1.655-8.736-6.692-10.241-11.206-1.142-3.4.186-7.834,3.833-12.835a.374.374,0,0,1,.6.443c-3.5,4.8-4.789,9-3.727,12.162.956,2.85,4.32,6.5,9.993,10.852a45.149,45.149,0,0,0,9.542,5.6c.186.08.345.15.5.212a46.018,46.018,0,0,0,4.5,1.62l7.55-23.005q-2.138-.863-4.284-1.726l-.5-.2q-2.589-1.049-5.2-2.1a.353.353,0,0,1-.221-.274.386.386,0,0,1,.1-.336l.062-.062c.177-.168.425-.425.744-.744,2.434-2.443,8.63-8.79,13.649-14.844a.371.371,0,1,1,.575.469C80.2,69.543,73.977,75.9,71.543,78.359l-.407.407,4.674,1.885.5.2c1.531.62,3.071,1.239,4.6,1.859a.365.365,0,0,1,.212.46l-7.772,23.678a.369.369,0,0,1-.354.257Z",
    transform: "translate(-47.131 -13.324)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17634",
    "data-name": "Path 17634",
    d: "M68.142,82.728a.369.369,0,0,1-.354-.266.379.379,0,0,1,.248-.469l4.691-1.425a.366.366,0,0,1,.46.248.386.386,0,0,1-.248.469L68.248,82.71a.626.626,0,0,1-.106.018Z",
    transform: "translate(-49.501 -15.356)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17635",
    "data-name": "Path 17635",
    d: "M103.794,97.462c-4.089,0-11.1-.4-11.18-.4a.372.372,0,1,1,.035-.744c.08,0,7.745.443,11.693.4h0a.374.374,0,0,1,.372.372.382.382,0,0,1-.372.381h-.566Z",
    transform: "translate(-52.313 -17.167)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17636",
    "data-name": "Path 17636",
    d: "M101.544,104.915a90.612,90.612,0,0,1-9.976-.69.371.371,0,0,1,.1-.735c.08.009,8.152,1.036,12.914.558a.365.365,0,0,1,.407.336.376.376,0,0,1-.336.407,31.063,31.063,0,0,1-3.107.133Z",
    transform: "translate(-52.197 -17.99)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17637",
    "data-name": "Path 17637",
    d: "M100.5,111.076a59.092,59.092,0,0,1-9.923-1.071.365.365,0,0,1-.292-.434.376.376,0,0,1,.434-.292c.071.018,7,1.381,11.657.983a.369.369,0,0,1,.062.735c-.62.053-1.275.071-1.947.071Z",
    transform: "translate(-52.086 -18.655)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17638",
    "data-name": "Path 17638",
    d: "M155.712,70.631h-.027a.375.375,0,0,1-.345-.4c0-.071.558-7.559.637-9.409a.349.349,0,0,1,.389-.354.369.369,0,0,1,.354.389c-.08,1.859-.637,9.356-.637,9.427A.375.375,0,0,1,155.712,70.631Z",
    transform: "translate(-59.558 -13.05)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17639",
    "data-name": "Path 17639",
    d: "M162.963,70.74h0a.368.368,0,0,1-.363-.381c0-.044.1-4.78.283-9.9a.371.371,0,0,1,.389-.363.377.377,0,0,1,.363.389c-.186,5.107-.283,9.843-.283,9.887a.366.366,0,0,1-.372.363Z",
    transform: "translate(-60.392 -13.007)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17640",
    "data-name": "Path 17640",
    d: "M169.152,70.2h0a.374.374,0,0,1-.372-.372,75.654,75.654,0,0,0-.46-8.223.376.376,0,0,1,.327-.416.383.383,0,0,1,.416.328,77.286,77.286,0,0,1,.46,8.312A.374.374,0,0,1,169.152,70.2Z",
    transform: "translate(-61.048 -13.132)",
    fill: "#060e12"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_17641",
    "data-name": "Path 17641",
    d: "M219.377,149.734H.372a.372.372,0,0,1,0-.744h219a.372.372,0,1,1,0,.744Z",
    transform: "translate(0 -17.182)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17642",
    "data-name": "Path 17642",
    d: "M116.557,80.851V79.39a6.078,6.078,0,0,0-5.665,3.912H109.06v1.461h1.469a5.27,5.27,0,0,0,0,1.363H109.06v1.461h1.832a6.06,6.06,0,0,0,5.665,3.912V90.038a4.6,4.6,0,0,1-4.045-2.452h3.5V86.126h-3.992a3.315,3.315,0,0,1,0-1.363h3.992V83.3h-3.5A4.577,4.577,0,0,1,116.557,80.851Z",
    transform: "translate(-12.525 -9.188)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfeili);
export default __webpack_public_path__ + "static/media/ofeili.75efb13898bdb61f64ff1ec70da06f2f.svg";
export { ForwardRef as ReactComponent };